import React from 'react'
import styled from 'styled-components'

/**
 * 画面ごとの選択肢等表示エリア
 */
const ContentArea: React.FC<ContentAreaProps> = (props) => {
  return <StyledContentArea>{props.content}</StyledContentArea>
}

export type ContentAreaProps = {
  content?: React.ReactNode
}

export const StyledContentArea = styled.div`
  background: var(--color-background);
`
export default ContentArea
